import { Component, OnInit, ViewChild } from "@angular/core";
import { FieldType } from "@ngx-formly/core";
import { ReCaptcha2Component } from "ngx-captcha";

@Component({
  // selector: 'sanremo-recaptcha',
  template: `
    <ngx-recaptcha2
      #captchaElem
      [siteKey]="to.siteKey"
      [formControl]="formControl"
      (error)="handleError()"
    >
    </ngx-recaptcha2>
  `,
  styles: []
})
export class SanremoRecaptchaComponent extends FieldType implements OnInit {
  @ViewChild("captchaElem") captchaElem: ReCaptcha2Component;

  //   siteKeyValid: true;

  handleError() {
    this.captchaElem.captchaWrapperElem.nativeElement.style.display = "none";
    // this.to.siteKeyValid = false;

    if (this.to.callback) {
      this.to.callback(this.captchaElem, false);
    }
  }

  ngAfterViewInit() {
    if (this.to.callback) {
      // this.to.required = this.validSiteKey;
      this.to.callback(this.captchaElem, true);
    }
  }

  constructor() {
    super();
  }

  ngOnInit() {}
}
